import React from "react";
import { connect } from "react-redux";
import { OrderedMap } from "immutable";
import Toolbox from "dashboard/components/Toolbox";
import Select from "components/library/Select";
import {
  getCurationListAsync,
  getCurationListNextPageAsync,
} from "curation/actions/list";
import { setCurationFilter, unsetAllFilters } from "curation/actions/filters";
import CurationList from "../CurationList";

import styles from "./CurationDash.css";

const mapStateToProps = state => ({
  list: state.curation.list,
  filters: state.curation.filters,
  isLoadingInitialList: state.curation.ui.isLoadingInitialList,
});

const mapDispatchToProps = {
  getCurationListAsync,
  getCurationListNextPageAsync,
  setCurationFilter,
  unsetAllFilters,
};

class CurationDash extends React.Component {
  componentDidMount() {
    this.props.unsetAllFilters();
    this.props.setCurationFilter(this.props.filter);
    this.props.getCurationListAsync();
  }

  render() {
    let stories = [];

    if (this.props.list && OrderedMap.isOrderedMap(this.props.list.items)) {
      stories = this.props.list.items.toArray();
    }

    const sort = { label: "", value: "" };

    return (
      <div className={styles.root}>
        <Toolbox>
          <Select
            onChange={() => {}}
            className={styles.sortDropdown}
            disabled={true}
          >
            <option key={sort.value} value={sort.value}>
              {sort.label}
            </option>
          </Select>
        </Toolbox>
        <div className={styles.stories}>
          <CurationList
            stories={stories.map(convertDeepDive)}
            next={this.props.getCurationListNextPageAsync}
            isLoadingInitialList={this.props.isLoadingInitialList}
            showPublishedDatetime={true}
          />
        </div>
      </div>
    );
  }
}

const convertDeepDive = deepDive => {
  return {
    ...deepDive,
    content_type: "deep-dive",
    status: deepDive.public ? "published" : "in-progress",
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CurationDash);
